<ul class="list-container">
    <li class="list-item" *ngFor="let item of menuList" (click)="itemClick(item.action)">
        <i [class]="item.icon"></i>
        <label class="label">{{ item.name }}</label>
    </li>
</ul>
